module.exports = __webpack_public_path__ + "img/sea_white.44afc42c.svg";